import React from 'react'
import { Form } from 'react-bootstrap'

const Content = ({
    value = '',
    onChange = () => {}
}) => {

    return (
        <Form.Group>
            <Form.Label>Message</Form.Label>
            <Form.Control
                as="textarea"
                rows={5}
                value={value}
                onChange={e => onChange(e.target.value)}
            />
        </Form.Group>
    )
}

export default Content
